import React, { useState, useEffect } from "react";
import RecurrenciaSelector from "./RecurrenciaSelector";
import Loader from "../general/Loader";
import Select from "react-select";
import dayjs from "dayjs";
import { auth } from "../../utils/auth";
import Fields from "./Fields";
import { formatCurrency, toast } from "../../utils/helpers";
import ItemCompra from "./ItemCompra";
import { apiRequest } from "../../hooks/apiRequest";
import ProductoCompra from "./ProductoCompra";
import SuministroCompra from "./SuministroCompra";
import EditableInput from "../general/EditableInput";

const CompraRecurrenteForm = ({ compraRecurrente = { compra: {} }, onSubmit, saving, errors = {}, contacto,updateContacto, isCreate }) => {
    const initialRecurrencia = React.useMemo(() => {
        const values = compraRecurrente.values || {};

        return {
            frecuencia: compraRecurrente.frecuencia || "semanal",
            cada: compraRecurrente.cada || 1,
            fechaInicio: compraRecurrente.fecha_inicio || dayjs().format("YYYY-MM-DD"),
            ocurrencias: compraRecurrente.ocurrencias || -1,
            weekdays: values.weekdays || [1,2,3,4,5,6,7],
            days: values.days || [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
            months: values.months || [1,2,3,4,5,6,7,8,9,10,11,12],
        };
    }, [compraRecurrente]);

    const [recurrencia, setRecurrencia] = useState(initialRecurrencia);
    const [tipoDescuento, setTipoDescuento] = useState(compraRecurrente.compra.tipoDescuento ?? 'Monto Fijo');
    const [state, setState] = useState({
        vencimiento: compraRecurrente.compra.vencimiento
            ? compraRecurrente.compra.vencimiento
            : dayjs().format("YYYY-MM-DD"),
        almacen: null,
        prevTotal: 0,
        tipo: compraRecurrente.compra.tipo ?? 'producto',
        total: compraRecurrente.compra.items?.reduce((accum, item) => {
            return accum + item.total;
        }, 0),
    });
    const [impuestos, setImpuestos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [desc, setDescuento] = useState(compraRecurrente.compra.descuento || 0);
    const [total, setTotal] = useState(compraRecurrente.compra.total || 0);

    const [compraItems, setCompraItems] = useState(compraRecurrente.compra.items || []);

    const getTable = async (url = null, label = 'nombre', value = 'id') => {
        const table = await apiRequest({}, url, 'get');
        if (table.data) {
            return table.data;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        onSubmit(e);
    };

    const addItem = (tipo) => {
        setCompraItems([
            ...compraItems,
            {
                id: Date.now(),
                cantidad: 1,
                descuento: 0,
                tipo: tipo,
                impuesto: { nombre: "Ninguno", porcentaje: 0, totalImpuesto: 0 },
            },
        ]);
	};

    const removeItem = async (item) => {
        const ci = compraItems.filter((i) => i.id !== item);
		setCompraItems(ci);

        const subT = ci.reduce((p, c) => {
            return p + parseFloat(c.total) - parseFloat(c.impuesto?.totalImpuesto);
        }, 0);
	};

    const updateTotal = (id = null, value = 0, impuesto = {}, descuento = 0, ignoreTotals = false) => {
        const ci = compraItems.map((item) => {
            if (item.id === id) {
                item.descuento = descuento;
                item.total = value;
                item.tipo = item.tipo;
                item.impuesto = impuesto;
                item.totalImpuesto = impuesto.totalImpuesto;
            }
            return item;
        });

		setCompraItems(ci);
	};

    const onChangeDescuento = (value) => {
        if (value > total) {
            toast('El descuento no puede ser mayor al valor de la compra');
            setDescuento(0);
        } else {
            setDescuento(value);
        }
    };

    useEffect(() => {
        setTotal(compraItems.reduce((p, c) => {
            return p + parseFloat(c.total);
        }, 0));
    }, [compraItems]);

    useEffect(() => {
        getTable('impuestos').then(setImpuestos);
        getTable('grupos').then(setGrupos);
    }, []);

    const { almacen, tipo } = state;

    const productosCompra = compraItems.filter(i => i.tipo === 'producto');
    const itemsCompra = compraItems.filter(i => i.tipo === 'item');
    const suministrosCompra = compraItems.filter(i => i.tipo === 'suministro');

    const totalProductos = productosCompra.reduce((p, c) => {
		return p + parseFloat(c.total);
	}, 0);

    const totalItems = itemsCompra.reduce((p, c) => {
		return p + parseFloat(c.total);
	}, 0);

    const totalSuministros = suministrosCompra.reduce((p, c) => {
		return p + parseFloat(c.total);
	}, 0);

    const totalesDescuentos = compraItems.reduce((acc, item) => {
        return acc + item.descuento;
	}, 0);

    const detalleTotal = [...itemsCompra, ...productosCompra, ...suministrosCompra].reduce((detalle, items) => {
        const impuesto = items.impuesto?.nombre || 'sin impuesto';
        const totalImpuesto = parseFloat(items.impuesto?.totalImpuesto) || 0;
        
        if (!detalle[impuesto]) {
            detalle[impuesto] = totalImpuesto;
        } else {
            detalle[impuesto] += totalImpuesto;
        }

        detalle.Subtotal += (detalle.subtotal || 0) + parseFloat(items.total) - totalImpuesto;

        return detalle;
    }, {Subtotal: 0});

    const gTotal = total - desc;

    return <form onSubmit={handleSubmit}>
        <div className="col-12">
            <RecurrenciaSelector value={recurrencia} onChange={setRecurrencia} />
        </div>

        <hr></hr>

        <div className="row">
            <Fields
                errors={errors}
                compra={compraRecurrente.compra}
                contacto={contacto}
                updateContacto={updateContacto}
                setTipoDescuento={setTipoDescuento}
                tipoDescuento={tipoDescuento}
            />
            <input type="hidden" name="user_id" value={auth.getUser().id}/>
            <input type="hidden" name="tipo" value={tipo} />

            <div className="compra-tabs col-md-12">
                <button
                    type="button"
                    className={`compra-tab ${
                        tipo === "producto"
                            ? "active"
                            : ""
                    }`}
                    onClick={() =>
                        setState({ ...state, tipo: "producto" })
                    }
                >
                    INVENTARIO <strong>({productosCompra.length}) ({formatCurrency(totalProductos)})</strong>
                </button>
                <button
                    type="button"
                    className={`compra-tab ${
                        tipo === "item"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => setState({ ...state, tipo: "item" })}
                >
                    ACTIVOS <strong>({itemsCompra.length}) ({formatCurrency(totalItems)})</strong>
                </button>
                <button
                    type="button"
                    className={`compra-tab ${
                        tipo === "suministro"
                            ? "active"
                            : ""
                    }`}
                    onClick={() =>
                        setState({ ...state, tipo: "suministro" })
                    }
                >
                    TRABAJO/SUMINISTRO <strong>({suministrosCompra.length}) ({formatCurrency(totalSuministros)})</strong>
                </button>
            </div>

            <div className="col-md-12" style={{display: tipo === 'producto' ? 'block' : 'none'}}>
                <table className="table">
                    <thead>
                        <tr>
                            <th width="35px" className="text-center"></th>
                            <th width="28%">Producto</th>
                            {/* <th width="10%">Ref./Código</th> */}
                            <th width="75px" className="text-center">
                                Cant.
                            </th>
                            <th width="10%">
                                Importe
                            </th>
                            <th width="10%">
                                Impuesto
                            </th>
                            <th width="10%">
                                Desc.
                            </th>
                            <th width="10%">
                                Precio
                            </th>
                            <th width="10%" className="text-right">
                                Total
                            </th>
                            <th width="110px" className="text-right p-l-15">
                                Precios Venta
                            </th>
                            <th width="25px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosCompra.map((item, index) => {
                            return (
                                <ProductoCompra
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    impuestos={impuestos}
                                    almacen={almacen}
                                    tipoDescuento={tipoDescuento}
                                    removeItem={removeItem}
                                    updateTotal={updateTotal}
                                />
                            );
                        })}

                        <tr>
							<td colSpan="10" className="text-right">
								<button
									type="button"
									onClick={() => addItem('producto')}
									className="btn"
								>
									<i className="fas fa-plus" /> Agregar Item
								</button>
							</td>
						</tr>
                    </tbody>
                </table>
            </div>

            <div className="col-md-12" style={{display: tipo === 'item' ? 'block' : 'none'}}>
                    <table className="table">
					<thead>
                        <tr>
                            <th className="text-center"></th>
                            <th width="30%">Items</th>
                            <th width="10%">Ref./Código</th>
                            <th className="text-center" width="10%">
                                Cantidad
                            </th>
                            <th className="text-center" width="15%">
                                Costo
                            </th>
                            <th className="text-center" width="10%">
                                Impuesto
                            </th>
                            <th className="text-center" width="15%">
                                Categoria
                            </th>
                            <th className="text-right" width="15%">
                                Total
                            </th>
                            <th width="25px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsCompra.map((item, index) => {
                            return (
                                <ItemCompra
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    impuestos={impuestos}
                                    grupos={grupos}
                                    tipo={tipo}
                                    almacen={almacen}
                                    removeItem={removeItem}
                                    updateTotal={updateTotal}
                                    isCreate={isCreate}
                                />
                            );
                        })}

                        <tr>
							<td colSpan="10" className="text-right">
								<button
									type="button"
									onClick={() => addItem('item')}
									className="btn"
								>
									<i className="fas fa-plus" /> Agregar Item
								</button>
							</td>
						</tr>
                    </tbody>
                </table>
            </div>

            <div className="col-md-12" style={{display: tipo === 'suministro' ? 'block' : 'none'}}>

                    <table className="table">
					<thead>
                        <tr>
                            <th width="25px" className="text-center"></th>
                            <th colSpan={2}>Descripción</th>
                            <th className="text-center" width="90px">
                                Cantidad
                            </th>
                            <th className="text-center" width="15%">
                                Costo
                            </th>
                            <th className="text-center" colSpan={2}>
                                Impuesto
                            </th>
                            <th className="text-right" width="12%">
                                Total
                            </th>
                            <th width="25px"></th>
                        </tr>
					</thead>
					<tbody>
                            {suministrosCompra.map((item, index) => (
                                <SuministroCompra
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    impuestos={impuestos}
                                    tipo={tipo}
                                    removeItem={removeItem}
                                    updateTotal={updateTotal}
                                    isCreate={isCreate}
                                />
                            ))}
                        <tr>
							<td colSpan="10" className="text-right">
								<button
									type="button"
									onClick={() => addItem('suministro')}
									className="btn"
								>
									<i className="fas fa-plus" /> Agregar Item
								</button>
							</td>
						</tr>
					</tbody>
				</table>
            </div>
        </div>

        <div className="col-md-12">
            <table className="table">
                <tbody>
                    {totalesDescuentos > 1 && (
                        <tr>
                            <td className="text-right">
                                <strong className="label form-control-label">
                                    Total Descuentos:
                                </strong>
                            </td>
                            <td className="text-right">
                                {formatCurrency(totalesDescuentos)}
                            </td>
                        </tr>
                    )}
                    {Object.keys(detalleTotal).map((imp) => (
                        <tr key={imp}>
                            <td className="text-right">
                                <strong className="label form-control-label capitalize">
                                    {imp}:
                                </strong>
                            </td>
                            <td>
                                <div className="float-right" style={{maxWidth: "60%"}}>
                                    <span>{formatCurrency(detalleTotal[imp])}</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td className="text-right">
                            <strong className="label form-control-label">
                                Descuento General:
                            </strong>
                        </td>
                        <td className="text-right p-l-15">
                            <div className="float-right d-flex">
                                <div className="input-group" style={{justifyContent: 'flex-end'}}>
                                    {tipoDescuento === 'Monto Fijo' && (
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon1">RD$</span>
                                        </div>
                                    )}
                                    <input type="number"  onChange={e => onChangeDescuento(e.target.value)} style={{maxWidth: "50%"}} className="form-control text-right" name="descuento" value={desc} />
                                    {tipoDescuento === 'Porcentaje' && (
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon1">%</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-right">
                            <strong className="label form-control-label">
                                Total:
                            </strong>
                        </td>
                        <td className="text-right" width="20%">
                            <input
                                type="hidden"
                                name="compra[total]"
                                value={gTotal || ''}
                            />
                            {formatCurrency(gTotal)}
                            {errors.total && (
                                <small className="help-blockParams form-Text">
                                    {errors.total[0]}
                                </small>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div className="row">
            <div className="col-12 d-flex justify-content-end">
                <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? "Guardando..." : "Guardar"}
                </button>
            </div>
        </div>
    </form>
};

export default CompraRecurrenteForm;